import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { AbstractControl, FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { MessageService } from 'primeng/api';
import { ConfigService } from 'src/app/core/services/config/config.service';
import { HttphelperService } from 'src/app/core/services/helpers/httphelper.service';
import { IRegister } from 'src/app/models/iregister';

@Component({
  selector: 'app-register',
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.scss']
})
export class RegisterComponent implements OnInit {
  activeIndex: number = 0;
  isLoading:boolean=false;
  isDisabledRegister:boolean=true;
  isDisabledPasscodeRegister:boolean=true;
  mobileAppLinkTermsOfUse:string="";
  mobileAppLinkPrivcyPolicy:string="";
  userNameLabel:string="";
  FieldName:string="";
  userNamePlaceHolder:string="";
  phoneNumberPlaceHolder:string="";
  userNamePattern:string="";
  mobileExpression:string="";
  SSNExpression:string="";
  showMiddleName:boolean=false;
  middelNameMandatory:boolean=false;
  SSNMandatory:boolean=false;
  myRegisterForm: FormGroup;
  myRegisterFormWithPasscode: FormGroup;
  APPMainsettings:any=[];
  // messageUserName:string="";
  // messageFirstName:string="";
  // private validationMessages={
  //   required:'Please enter',
  //   email:'Please enter valid ',
  //   pattern:'Please enter valid format'
  // };
  constructor(private fb:FormBuilder,private helperService:HttphelperService,private router:Router,private messageService:MessageService,public datepipe: DatePipe) {
    this.APPMainsettings = ConfigService.APPMainsettings;
    var loginField = this.APPMainsettings.LoginField.filter((obj) => {
      return obj.isloginfield;
    })[0];
    this.userNameLabel = loginField?.LatLabel;
    this.FieldName = loginField?.FieldName;

    this.showMiddleName = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "MiddelNameSHow";
    })[0]?.Value == "1" ? true : false;

    this.middelNameMandatory = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "MiddelNameMandatory";
    })[0]?.Value == "1" ? true : false;

    this.SSNMandatory = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "SSNMandatory";
    })[0]?.Value == "1" ? true : false;

    this.phoneNumberPlaceHolder = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "PhoneNumberPlaceHolder";
    })[0].ValueL;

    this.mobileAppLinkTermsOfUse = this.APPMainsettings.MenuLinks.filter((obj) => {
      return obj.key == "MobileAppLinkTermsOfUse";
    })[0]?.val;

    this.mobileAppLinkPrivcyPolicy = this.APPMainsettings.MenuLinks.filter((obj) => {
      return obj.key == "MobileAppLinkPrivcyPolicy";
    })[0]?.val;

    if(this.FieldName == 'Mobile'){
      this.userNamePlaceHolder = this.phoneNumberPlaceHolder;
    }
    this.SSNExpression = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "SSNExpression";
    })[0].Value;
    
    this.mobileExpression = this.APPMainsettings.Validations.filter((obj) => {
      return obj.Key == "MobileExpression";
    })[0].Value;

    if(this.FieldName == 'SSN'){
      this.userNamePattern = this.SSNExpression;
    }
    else if(this.FieldName == 'Mobile'){
      this.userNamePattern = this.mobileExpression;
    }
  }

  ngOnInit(): void {
    this.myRegisterForm = this.fb.group({
      userName: ['',[Validators.required,Validators.pattern(this.userNamePattern)]],
      firstName: ['',[Validators.required]],
      middleName: [''],
      lastName: ['',[Validators.required]],
      birthDate: ['',[Validators.required]],
      gender: ['1', Validators.required],
      passwordGroup:this.fb.group({
        password: ['', {validators:[Validators.required,Validators.minLength(6)], updateOn: "blur"}],
        confirmPassword: ['',{validators: [Validators.required,Validators.minLength(6)], updateOn: "blur"}]
      },{validator:this.passwordMatcher}),
      mobileNumber:['',{validators:[Validators.required,Validators.pattern(this.mobileExpression)], updateOn: "blur"}],
      SSNumber: ['',{validators:[Validators.pattern(this.SSNExpression)], updateOn: "blur"}],
      email: ['',[Validators.email]],
      address: [''],
      terms:['0']
    });
    if(this.FieldName == 'Email'){
      var userNameForm = this.myRegisterForm.get('userName');
      userNameForm.setValidators([Validators.required,Validators.email]);
      userNameForm.updateValueAndValidity();
    }
    if(this.middelNameMandatory){
      var middleNameForm = this.myRegisterForm.get('middleName');
      middleNameForm.setValidators([Validators.required]);
      middleNameForm.updateValueAndValidity();
    }
    if(this.SSNMandatory){
      var SSNumberForm = this.myRegisterForm.get('SSNumber');
      SSNumberForm.setValidators([Validators.required,Validators.pattern(this.SSNExpression)]);
      SSNumberForm.updateValueAndValidity();
    }

    const termsControl = this.myRegisterForm.get('terms');
    termsControl.valueChanges.subscribe(value =>{
      this.isDisabledRegister = termsControl.value.length > 1 ? false : true;
    });

    this.myRegisterFormWithPasscode = this.fb.group({
      passcode: ['',[Validators.required]],
      userName: ['',[Validators.required,Validators.pattern(this.userNamePattern)]],
      passwordGroup:this.fb.group({
        password: ['', {validators:[Validators.required,Validators.minLength(6)], updateOn: "blur"}],
        confirmPassword: ['',{validators: [Validators.required,Validators.minLength(6)], updateOn: "blur"}]
      },{validator:this.passwordMatcher}),
      terms:['0']
    });
    const termsPasscodeControl = this.myRegisterFormWithPasscode.get('terms');
    termsPasscodeControl.valueChanges.subscribe(value =>{
      this.isDisabledPasscodeRegister = termsPasscodeControl.value.length > 1 ? false : true;
    });
    if(this.FieldName == 'Email'){
      var userNameForm = this.myRegisterFormWithPasscode.get('userName');
      userNameForm.setValidators([Validators.required,Validators.email]);
      userNameForm.updateValueAndValidity();
    }
  }
  // setMessageValidation(c:AbstractControl,feildName:string):void{
  //  var messageDisplay:string = '';
  //  if((c.touched || c.dirty) && c.errors){
  //   messageDisplay = Object.keys(c.errors).map(
  //     key => (this.validationMessages[key]) +' '+ feildName).join(' ');
  //   }
  //   if(feildName == 'user name'){
  //     this.messageUserName = messageDisplay;
  //   }
  //   else if(feildName == 'first name'){
  //     this.messageFirstName = messageDisplay;
  //   }
  //   else if(feildName == 'middle name'){
  //     this.messageFirstName = messageDisplay;
  //   }
  //   else if(feildName == 'last name'){
  //     this.messageFirstName = messageDisplay;
  //   }
  //   else if(feildName == 'first name'){
  //     this.messageFirstName = messageDisplay;
  //   }
    
  // }
  register(withPasscode:boolean){
    var passcode:string = "";
    var userName:string = "";
    var firstName:string = "";
    var middleName:string = "";
    var lastName:string = "";
    var mobileNumber:string = "";
    var gender:string = "";
    var password:string = "";
    var confirmPassword:string = "";
    var birthDate:string = "";
    var SSNumber:string = "";
    var email:string = "";
    var address:string = "";
    if(withPasscode){
      if(!this.myRegisterFormWithPasscode.valid){
        this.messageService.add({severity: 'warn', summary: 'Warning', detail:'Please enter valid data', life: 2000});
        return;
      }
      passcode = this.myRegisterFormWithPasscode.get('passcode').value;
      userName = this.myRegisterFormWithPasscode.get('userName').value;
      password = this.myRegisterFormWithPasscode.get('passwordGroup.password').value;
      confirmPassword = this.myRegisterFormWithPasscode.get('passwordGroup.confirmPassword').value;
    }else{
      if(!this.myRegisterForm.valid){
        this.messageService.add({severity: 'warn', summary: 'Warning', detail:'Please enter valid data', life: 2000});
        return;
      }
      userName = this.myRegisterForm.get('userName').value;
      firstName = this.myRegisterForm.get('firstName').value;
      middleName = this.myRegisterForm.get('middleName').value;
      lastName = this.myRegisterForm.get('lastName').value;
      mobileNumber = this.myRegisterForm.get('mobileNumber').value;
      gender = this.myRegisterForm.get('gender').value;
      password = this.myRegisterForm.get('passwordGroup.password').value;
      confirmPassword = this.myRegisterForm.get('passwordGroup.confirmPassword').value;
      birthDate = this.datepipe.transform(this.myRegisterForm.get('birthDate').value, 'dd-MM-yyyy');
      SSNumber = this.myRegisterForm.get('SSNumber').value;
      email = this.myRegisterForm.get('email').value;
      address = this.myRegisterForm.get('address').value;
    }
    this.isLoading = true;
    let registerModel:IRegister={
      PassCode:passcode,
      userName:userName,
      firstName:firstName,
      MiddelName:middleName,
      lastName:lastName,
      mobileNumber:mobileNumber,
      Email:email,
      Address:address,
      SSNumber:SSNumber,
      Password:password,
      ConfirmPassword:confirmPassword,
      genderID:gender,
      dateOfBirth:birthDate,
      LangaugeId:0,
      CustomerLoginName:'',
      ExternalID:'',
      Image:''
    };

    var url = `/api/Account/Register`;
    this.helperService.postRequest(url,false,registerModel).subscribe(response =>
    {
      if(response.Success)
      {
        this.messageService.add({severity: 'success', summary: 'Success', detail:response.Message, life: 2000});
        this.router.navigate(['/login'])
      }
      else
      {
        this.messageService.add({severity: 'error', summary: 'Error', detail:response.Message, life: 2000});
      }   
      this.isLoading = false;
    },
    error=>{
        this.messageService.add({severity: 'error', summary: 'Error', detail: error, life: 2000});
        this.isLoading = false;
    })
  }
  backToLogin(){
    window.location.href = 'login';
  }
  passwordMatcher(c:AbstractControl):{[key:string]:boolean}|null{
    const password=c.get('password');
    const confirmPassword=c.get('confirmPassword');
    if(password.pristine || confirmPassword.pristine){
      return null;
    }
    if(password.value == confirmPassword.value){
      return null;
    }
    return {match:true}
  }
}
